const { CardTypes } = require("../../Constants/Names/CardNames");
const { CardDeck } = require("../../Constants/Names/CardTypes");
const BonusCard = require("../../entities/Cards/BonusCard");
const Card = require("../../entities/Cards/Card");
const TechnologyConverter = require("./TechnologyConverter");
const ActionConverter = require("./ActionConverter");
const LeaderConverter = require("./LeaderConverter");
const WonderConverter = require("./WonderConverter");
const EventConverter = require("./EventConverter");
const TerritoryConverter = require("./TerritoryConverter");
const TacticConverter = require("./TacticConverter");
const AggressionConverter = require("./AggressionConverter");
const WarConverter = require("./WarConverter");
const PactConverter = require("./PactConverter");

const CardConverter = (cardData) =>
{
    if (cardData === null || cardData === undefined)
    {
        return null;
    }
    var card = ConvertCard(cardData)
        // Leaders and wonders are not implemented yet; keep a placeholder so the state still round-trips
        ?? new Card(Object.values(CardTypes.CivilCardTypes).includes(cardData.type) ? CardDeck.Civil : CardDeck.Military, cardData.type, null, cardData.name, cardData.age, "Not implemented yet", {});
    card.id = cardData.id;
    card.cardData = { type: cardData.type, name: cardData.name, age: cardData.age, id: cardData.id, ...(cardData.version ? { version: cardData.version } : {}) };
    // (a leader or wonder the expansion changed: which version it is, see Constants/CardVersions.js)
    if (cardData.version)
    {
        card.version = cardData.version;
    }
    return card;
}

const ConvertCard = (cardData) =>
{
    switch(cardData.type)
    {
        case CardTypes.CivilCardTypes.Technology:
            return TechnologyConverter(cardData.name, cardData.version);
        case CardTypes.CivilCardTypes.Action:
            return ActionConverter(cardData.name, cardData.age);
        case CardTypes.CivilCardTypes.Leader:
            return LeaderConverter(cardData.name, cardData.version);
        case CardTypes.CivilCardTypes.Wonder:
            return WonderConverter(cardData.name, cardData.version);
        case CardTypes.MilitaryCardTypes.Event:
            return EventConverter(cardData.name);
        case CardTypes.MilitaryCardTypes.Territory:
            return TerritoryConverter(cardData.name, cardData.age, cardData.version);
        case CardTypes.MilitaryCardTypes.Bonus:
            return new BonusCard(cardData.age);
        case CardTypes.MilitaryCardTypes.Tactic:
            return TacticConverter(cardData.name);
        case CardTypes.MilitaryCardTypes.Aggression:
            return AggressionConverter(cardData.name, cardData.age);
        case CardTypes.MilitaryCardTypes.War:
            return WarConverter(cardData.name);
        case CardTypes.MilitaryCardTypes.Pact:
            return PactConverter(cardData.name);
        default:
            return null;
    }
}

module.exports = CardConverter;